import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
//进度条配置
NProgress.configure({
    easing: 'ease',  // 动画方式，和css动画属性一样（默认：ease）
    speed: 500,  // 递增进度条的速度，单位ms（默认： 200）
    showSpinner: false, // 右上角是否显示加载ico
    trickle: true,//是否自动递增
    trickleSpeed: 200, // 自动递增间隔
    // minimum: 0.3, // 初始化时的最小百分比，0-1（默认：0.08）
    // parent: '#container'//指定此选项以更改父容器（默认：body）
})
//使用参考
// NProgress.start()// 开始
// NProgress.set(0.4) // 设置进度，0-1
// NProgress.inc() // 增加一点点
// NProgress.done() // 完成


//下面两种方法可以解决 冗余导航 问题。 冗余导航简单来说就是重复触发了同一个路由。

//第一种方式的代码会捕获所有的错误，并返回一个rejected状态的Promise，这样可以避免在调用push方法时需要每次都去处理错误。
//这种方式适用于大多数情况下，因为它简单明了，能够满足基本的需求。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
//第二种方式的代码则更加灵活，它允许你传入额外的onResolve和onReject参数，这样在路由切换成功或失败时可以执行特定的操作。
//如果传入了这些额外的参数，则调用原始的push方法并传入这些参数；否则，就像第一种方式一样，捕获错误并返回一个rejected状态的Promise。
// const originalPush = VueRouter.prototype.push//方式二
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject){
//     return originalPush.call(this, location, onResolve, onReject)
//   }
//   return originalPush.call(this, location).catch((err) => err)
// }


// 路由
export const constantRoutes = [
    {path: '/', name: '/', redirect: '/icpHome'},
    {path: '/icpHome', name: 'IcpHome', component: ()=>import('@/views/components/HomePage.vue')},
    {path: '/icp555', name: 'IcpError555', component: () => import('@/views/555.vue')},
    {path: '/icp403', name: 'IcpError403', component: () => import('@/views/403')},
    {path: '/icp404', name: 'IcpError404', component: () => import('@/views/404')},
    {path: '/icpAbout', name: 'IcpAbout', component: ()=>import('@/views/components/AboutPage.vue')},
    {path: '/icpJournal', name: 'IcpJournal', component: ()=>import('@/views/components/JournalPage.vue')},
    // {path: '/icpLogin', name: 'IcpLogin', component: ()=>import('@/views/components/Login.vue')},

    //通配符路由要在最后
    {path: '/*', name: 'IcpError*', redirect: '/icp404'},
]


const router = createRouter()


//方法一：新旧路由合并后，创建全新的
export function resetRouter(newRouterData = constantRoutes) {
    router.matcher = createRouter(newRouterData).matcher
}

//方法二：原有的基础上添加
export function addRouter(addRouterData) {
    //如果新添加的路由和旧的路由名称一致，那就会自动覆盖掉，并且控制器会报一个黄色警告。
    for (const route of addRouterData) {
        router.addRoute('main', route);
    }
}


function createRouter(routes = constantRoutes) {// 创建 VueRouter 实例
    return new VueRouter({
        // base: '/zby-vue/',//跟构建项目时候使用的软链接名称一致，它用于指定应用的基路径。
        //不写mode的情况下，默认是hash 网址路径上会有一个#号,好处是兼容性更好；
        //history好处是更加美观，能去除IP地址中的#号,缺点是ie10以上才支持。
        mode: 'history',
        scrollBehavior: () => ({//设置路由切换时页面的滚动行为，使页面始终滚动到顶部位置。
            //y: 0, //在这个函数中，指定了 y 属性的值为 0。这意味着每次路由切换时，页面都会滚动到顶部位置。
            // 这样做的目的是确保用户在浏览不同路由页面时始终从顶部开始浏览，而不是停留在上一次浏览的位置。
        }),
        routes: routes,//路由
    })
}

//路由守卫，每次路由跳转的时候都触发
router.beforeEach((to, from, next) => {
    //每次切换页面时，调用进度条
    NProgress.start();

    //写一些操作，比如说：可以用来检测用户是否登录，判断是否能点击，等等。
    console.log('路由守卫')
    // console.log(to)//跳转到哪里
    // console.log(from)//原来是哪里
    next()
})

router.afterEach(() => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
    //也可以封装axios中使用，参考：https://www.cnblogs.com/lang7/p/15912678.html
})

//VueRouter官方还提供了两个功能来查看现有的路由：
// router.hasRoute()：检查路由是否存在。
// router.getRoutes()：获取所有路由记录的数组。
export default router
